import {FILTER_VALUE} from '@/constants/refund-amount'

export default (value: string | number, hasFilter?: boolean) => {
  if(!value) {
    return '0'
  }

  const number: string = hasFilter ? getFilteredValue(value) : String(value)
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const getFilteredValue = (value: string | number): string => {
  return String(Math.floor(Number(value) * FILTER_VALUE))
}
